import { WAITING_TIME } from 'coreOld/constants';
import { NotificationPosition } from 'coreOld/enums';
import { useCompanyPartsActions } from 'partsOld/hooks';
import { ICompanyPart } from 'partsOld/types';

import UomFormView from './UomFormView';

interface IProps {
  isEditOpen: boolean;
  closeModal: () => void;
  selectedItem?: Partial<ICompanyPart>;
}

const UomForm = ({ closeModal, selectedItem, isEditOpen }: IProps) => {
  const { upsertCompanyPart } = useCompanyPartsActions(NotificationPosition.MODAL);

  const onSubmit = () => (data) => {
    try {
      const dataToSend = {
        uomId: data?.uom,
        salesUom: data?.salesUom,
        externalUom: data?.externalUom,
        part: data?.part,
        manufacturerId: data?.manufacturerId,
        id: data?.id,
        packageUom: data?.packageUom,
        packageType: data?.packageType,
        taaStatus: data?.taaStatus,
        mfgPartStatus: data?.mfgPartStatus,
        companyPartStatus: data?.companyPartStatus,
      };

      upsertCompanyPart(dataToSend);

      setTimeout(() => {
        closeModal();
      }, WAITING_TIME);
    } catch (err) {}
  };

  return (
    <UomFormView
      onSubmit={onSubmit}
      closeModal={closeModal}
      selectedItem={selectedItem}
      isEditOpen={isEditOpen}
    />
  );
};

export default UomForm;
